import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useHandleCalendarEvent } from "services/calendar";

export default () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const { request, data, error } = useHandleCalendarEvent(() => {
    navigate("/", { state: { calendarEvent: { action: "confirm" } } });
  });
  useEffect(() => {
    request({
      status: queryParams.get("status")!,
      token: queryParams.get("token")!,
    });
  }, []);
  useEffect(() => {
    if (error) {
      navigate("/", { state: { calendarEvent: { action: "invalid" } } });
    }
  }, [error]);
  if (!data) return <></>;
  return <></>;
};
